<template>
  <window-container class="delivery-note card" style="width:960px;margin:0 auto;background-color:#fff;">
    <table style="font-size:18px;font-weight:bold;">
      <tr>
        <td style="padding:6px 0;">Packing List</td>
        <td style="padding:6px 0;text-align:right;">No.:
          <span v-if="form.id === 0" style="color:#838383;font-style:italic;">- NEW -</span>
          <span v-else>{{ form.id }}</span>
        </td>
      </tr>
    </table>
    <table class="table-border">
      <tr>
        <td class="td-border" style="width:200px;">&nbsp;</td>
        <td class="td-border" style="padding-left:10px;">
          <span style="font-weight:bold;">From Doc:</span>&nbsp;
          <el-radio-group v-model="form.doc_type">
            <el-radio label="pi">INV</el-radio>
            <el-radio label="po">PO</el-radio>
          </el-radio-group>&nbsp;
          <el-input v-model="form.doc_id" style="width:120px;"></el-input>&nbsp;
          <el-button type="primary" @click="load">Load</el-button>
        </td>
        <td class="td-border td-right td-padding">
          <span style="font-weight:bold;">Date:</span>&nbsp;<el-date-picker v-model="form.doc_date" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions" style="width:160px;"></el-date-picker>
        </td>
      </tr>
    </table>
    <table class="table-border">
      <tr>
        <td class="td-border" style="padding:10px;width:430px;">
          <table>
            <tr>
              <td colspan="2" style="font-weight:bold;">*Bill To:</td>
            </tr>
            <tr>
              <td colspan="2">
                <el-input v-model="form.company_name" style="width:340px;"></el-input>
                &nbsp;
                <el-button @click="csVisible = true">...</el-button>
              </td>
            </tr>
            <tr>
              <td colspan="2"><el-input type="textarea" v-model="form.company_address" :rows="4"></el-input></td>
            </tr>
            <tr>
              <td style="text-align:right;width:60px;font-weight:bold;">*ATTN:</td>
              <td>
                <el-input v-model="form.contact_name" style="width:160px;"></el-input>
              </td>
            </tr>
            <tr>
              <td style="text-align:right;font-weight:bold;">*TEL:</td>
              <td>
                <el-input v-model="form.contact_phone" style="width:160px;"></el-input>
              </td>
            </tr>
            <tr>
              <td style="text-align:right;font-weight:bold;">FAX:</td>
              <td>
                <el-input v-model="form.contact_fax" style="width:160px;"></el-input>
              </td>
            </tr>
          </table>
        </td>
        <td class="td-border td-label" style="width:100px;text-align:center;">
          <el-button icon="el-icon-arrow-right" @click="form.shipping_address = form.company_address"></el-button>
        </td>
        <td class="td-border td-label" style="vertical-align:top;padding:10px;">
          *Ship To:<br/>
          <el-input v-model="form.shipping_company_name" style="margin-bottom:6px;"></el-input><br/>
          <el-input type="textarea" v-model="form.shipping_address" :rows="6"></el-input><br/>
        </td>
      </tr>
    </table>
    <table class="table-border" style="margin-top:10px;">
      <tr>
        <td class="td-border td-label" style="width:80px;">Carton No.</td>
        <td class="td-border td-label" style="width:280px;">Part Number</td>
        <td class="td-border td-label" style="width:100px;">Brand</td>
        <td class="td-border td-label td-right">Qty(PCS)</td>
        <td class="td-border td-label">Size(cm)</td>
        <td class="td-border td-label">Weight(kg)</td>
        <td class="td-border td-label">C/O</td>
      </tr>
      <template v-for="(item, index) in productList">
        <tr :key="item.order_no + '1'">
          <td rowspan="2" class="td-border" style="vertical-align:top;">
            <number-input v-model.number="productList[index].order_no" style="width:30px;"></number-input><br/>
            <el-button type="text" @click="copyProduct(index)">&nbsp;copy</el-button><br/>
            <el-button type="text" style="color:red;" @click="delProduct(index)">&nbsp;del</el-button>
          </td>
          <td class="td-border"><el-input v-model="productList[index].part_no"></el-input></td>
          <td class="td-border"><el-input v-model="productList[index].brand"></el-input></td>
          <td class="td-border td-right"><number-input v-model.number="productList[index].qty" style="width:80px;"></number-input></td>
          <td class="td-border">
            <number-input v-model.number="productList[index].size_1" style="width:45px;"></number-input>*
            <number-input v-model.number="productList[index].size_2" style="width:45px;"></number-input>*
            <number-input v-model.number="productList[index].size_3" style="width:45px;"></number-input>
          </td>
          <td class="td-border"><number-input v-model.number="productList[index].weight" style="width:50px;"></number-input></td>
          <td class="td-border"><el-input v-model="productList[index].c_o" style="width:80px;"></el-input></td>
        </tr>
        <tr :key="item.order_no + '2'">
          <td colspan="7" class="td-border td-padding" style="vertical-align:top;">
            <el-input type="textarea" style="width:600px;" :rows="2" v-model="productList[index].remark" placeholder="remarks"></el-input>
          </td>
        </tr>
      </template>
      <tr>
        <td class="td-border" colspan="7" style="text-align:center;padding:10px;"><el-button type="primary" @click="addNew">++Add++</el-button></td>
      </tr>
      <tr>
        <td colspan="3" class="td-border td-label td-right" style="font-size:16px;">TOTAL</td>
        <td colspan="4" class="td-border">
          <table>
            <tr>
              <td style="font-size:16px;font-weight:bold;border-right:1px solid #CCC;">{{ productList.length }} Carton(s)</td>
              <td style="font-size:16px;font-weight:bold;border-right:1px solid #CCC;">Qty:{{ totalQty }}pcs</td>
              <td style="font-size:16px;font-weight:bold;">Weight:{{ totalWeight }}kg</td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <table class="table-border" style="margin-top:10px;">
      <tr>
        <td class="td-border" style="padding:10px;">
          <strong>Remarks:</strong><br/>
          <el-input type="textarea" :rows="6" v-model="form.remarks"></el-input>
        </td>
        <td class="td-border" style="padding:10px;">
          <strong>Internal Remarks:</strong><br/>
          <el-input type="textarea" :rows="3" v-model="form.internal_remarks"></el-input><br/>
          <strong>E-Reach Number:</strong><br/>
          <el-input v-model="form.e_r_no"></el-input>
        </td>
      </tr>
      <tr>
        <td colspan="2" class="td-border" style="padding:10px;">
          <strong>Sales:</strong>&nbsp;
          <el-select v-model="form.sales_id" style="width:160px;">
            <el-option v-for="item in salesList" :key="item.id" :label="item.realname" :value="item.id"></el-option>
          </el-select>
        </td>
      </tr>
    </table>
    <div style="padding:10px;margin:10px 0;">
      <el-button @click="save">Save</el-button>
      <el-button @click="reset">Reset</el-button>
      <el-button type="danger" @click="del" v-if="$route.params.id !== 'new'">Void</el-button>
    </div>
    <el-dialog title="Contact Search" :visible.sync="csVisible" :close-on-click-modal="false">
      <div style="margin-top:-20px;margin-bottom:10px;">
        <el-input v-model="csQuery" style="width:320px;"></el-input>
        &nbsp;<el-button type="primary" @click="csSearch">&nbsp;Search&nbsp;</el-button>
      </div>
      <table class="cystron-table">
        <tr>
          <th>Name</th>
          <th>Contact</th>
          <th>Sales</th>
          <th>&nbsp;</th>
        </tr>
        <tr v-for="item in csList" :key="item.id">
          <td>{{ item.company_name }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.sales_name }}</td>
          <td><el-button type="text" @click="csChoose(item)">选择</el-button></td>
        </tr>
        <tr v-if="csList.length === 0">
          <td colspan="4" style="text-align:center;padding:10px 0;">输入关键字搜索联系人</td>
        </tr>
      </table>
    </el-dialog>
  </window-container>
</template>

<script>
import NumberInput from '@/components/NumberInput.vue'
import NP from 'number-precision'
export default {
  components: {
    NumberInput
  },
  data () {
    return {
      form: {
        id: this.$route.params.id === 'new' ? 0 : parseInt(this.$route.params.id),
        company_id: null,
        contact_id: null,
        company_name: '',
        company_address: '',
        shipping_address: '',
        contact_name: '',
        contact_phone: '',
        contact_fax: '',
        doc_id: '',
        doc_type: 'po',
        doc_no: '',
        doc_date: new Date(),
        delivery_date: null,
        fob_point: '',
        payment_terms: '',
        forwarder: '',
        total_qty: 0,
        total_carton: 0,
        total_weight: 0,
        remarks: '',
        internal_remarks: '',
        e_r_no: '',
        terms: `1.	All goods must be new,unused,original factory sealed packing ,full original factory label and no oxidation. 
2.	All goods must meet manufacture's specification and function.
3.	Please use the most suitable box with foam material stuffed for package in case of damage during shipment.
4.	Delivery must be on time as required by us.
5.	Supplier need to provide Proforma Invoice with bank information.
6.	If the above conditions are not met,We have the rights to return the goods for refund.
7.	We have the right to claim compensation for the loss by the supplier’s problem.`,
        sales_id: null
      },
      productList: [],
      contactList: [],
      pickerOptions: {
        shortcuts: [{
          text: 'today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'yesterday',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'a week ago',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      csVisible: false,
      csQuery: '',
      csList: []
    }
  },
  computed: {
    totalQty () {
      let t = 0
      for (let i = 0; i < this.productList.length; i++) {
        t += parseInt(this.productList[i].qty)
      }
      return t
    },
    totalWeight () {
      let t = 0
      for (let i = 0; i < this.productList.length; i++) {
        t = NP.plus(t, parseFloat(this.productList[i].weight))
      }
      return t
    },
    salesList () {
      return this.$store.state.select.sales
    }
  },
  mounted () {
    this.fetchDoc()
    this.fetchProductList()
    this.$store.dispatch('fetchSelect', 'sales')
  },
  methods: {
    fetchDoc () {
      if (this.$route.params.id !== 'new') {
        this.$http.get('/dbapi/packing_list?id=' + this.$route.params.id).then(data => {
          if (data.list.length > 0) {
            let doc = data.list[0]
            this.form = { ...doc }
          } else {
            this.$message({
              type: 'error',
              message: data.message
            })
          }
        })
      }
    },
    fetchProductList () {
      if (this.$route.params.id !== 'new') {
        this.$http.get('/dbapi/packing_details?id=' + this.$route.params.id).then(data => {
          this.productList = data.list.map(p => {
            return {
              order_no: p.order_no,
              part_no: p.part_no,
              description: p.description,
              brand: p.brand,
              qty: p.qty,
              size_1: p.size_1,
              size_2: p.size_2,
              size_3: p.size_3,
              weight: p.weight,
              c_o: p.c_o,
              remark: p.remark
            }
          })
        })
      } else if (this.$route.query.doc_no) {
        this.form.doc_type = this.$route.query.doc_no.substr(0, 2)
        this.form.doc_id = this.$route.query.doc_no.substr(2)
        this.load()
      } else {
        this.productList = []
      }
    },
    load () {
      let type = this.form.doc_type
      let id = this.form.doc_id.replace(type.toUpperCase(), '').replace(type, '').replace('CYS', '').replace('cys', '').replace('CY', '').replace('cy', '').replace(' ', '')
      this.loadDoc(type, id)
      this.loadProductList(type, id)
    },
    loadDoc (type, id) {
      this.$http.get('/dbapi/' + type + '_doc_list?id=' + id).then(data => {
        if (data.list.length > 0) {
          let doc = data.list[0]
          this.form = { 
            id: 0,
            company_id: doc.company_id,
            contact_id: doc.contact_id,
            company_name: doc.company_name,
            company_address: doc.company_address,
            shipping_address: doc.shipping_address,
            shipping_company_name: doc.shipping_company_name || '',
            contact_name: doc.contact_name,
            contact_phone: doc.contact_phone,
            contact_fax: doc.contact_fax,
            doc_id: id,
            doc_type: type,
            doc_no: type.toUpperCase() + 'CYS' + id,
            doc_date: doc.doc_date,
            delivery_date: doc.delivery_date,
            fob_point: doc.fob_point,
            payment_terms: doc.payment_terms,
            forwarder: doc.forwarder,
            total_qty: 0,
            total_weight: 0,
            total_carton: 0,
            remarks: doc.remarks,
            internal_remarks: doc.internal_remarks,
            e_r_no: doc.e_r_no,
            terms: doc.terms,
            sales_id: doc.sales_id
          }
        }
      })
    },
    loadProductList (type, id) {
      this.$http.get('/dbapi/' + type + '_doc_details?id=' + id).then(data => {
        this.productList = data.list.map(p => {
          return {
            order_no: p.order_no,
            part_no: p.part_no,
            description: p.description,
            brand: p.brand,
            qty: p.qty,
            size_1: 0,
            size_2: 0,
            size_3: 0,
            c_o: '',
            weight: 0,
            remark: p.remark
          }
        })
      })
    },
    addNew () {
      this.productList.push({
        order_no: this.productList.length + 1,
        part_no: '',
        description: '',
        brand: '',
        qty: 0,
        size_1: 0,
        size_2: 0,
        size_3: 0,
        weight: 0,
        c_o: '',
        remark: ''
      })
    },
    searchContact (query) {
      this.$http.get('/dbapi/company_contact_combo', {
        params: {
          query,
          limit: 30
        }
      }).then(data => {
        this.contactList = data.list
      })
    },
    save () {
      if (!this.form.company_id) {
        this.$message({
          type: 'error',
          message: 'Please select a company'
        })
        return
      }
      this.form.total_carton = this.productList.length
      this.form.total_qty = this.totalQty
      this.form.total_weight = this.totalWeight
      this.form.products = this.productList.filter(p => p.part_no != '')
      let url = '/dbapi/packing_list_insert'
      if (this.$route.params.id !== 'new') {
        url = '/dbapi/packing_list_update'
      }
      this.$http.post(url, this.form).then(data => {
        this.$message({
          type: 'success',
          message: 'Saved.'
        })
        window.opener && window.opener.postMessage('cystron', '*') // 刷新主页列表
        if (this.$route.params.id !== 'new') {
          this.$router.push('/packing-list-view/' + this.$route.params.id)
        } else {
          this.$router.push('/packing-list-view/' + data.insertId)
        }
      })
    },
    reset () {
    },
    del () {
      this.$confirm('确定要作废吗?', 'Confirm', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/packing_list_del', { id: this.$route.params.id }).then(data => {
          this.$close()
        })
      })
    },
    copyProduct (index) {
      this.productList.push({
        order_no: this.productList.length + 1,
        part_no: this.productList[index].part_no,
        description: this.productList[index].description,
        brand: this.productList[index].brand,
        qty: this.productList[index].qty,
        size_1: this.productList[index].size_1,
        size_2: this.productList[index].size_2,
        size_3: this.productList[index].size_3,
        weight: this.productList[index].weight,
        c_o: this.productList[index].c_o,
        remark: this.productList[index].remark
      })
    },
    delProduct (index) {
      this.$confirm('确定要删除吗?', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.productList.splice(index, 1)
      })
    },
    csSearch () {
      this.$http.get('/dbapi/company_contact_list_2?limit=100&query=' + encodeURIComponent(this.csQuery)).then(data => {
        this.csList = data.list
      })
    },
    csChoose (contact) {
      this.csVisible = false
      this.form.company_id = contact.company_id
      this.form.company_name = contact.company_name
      this.form.company_address = contact.company_address
      // this.form.shipping_address = contact.ship_address || contact.company_address
      this.form.contact_name = contact.name
      this.form.contact_phone = contact.phone || contact.company_phone
      this.form.contact_fax = contact.fax || contact.company_fax
      this.form.sales_id = contact.sales_id
    }
  }
}
</script>

<style lang="scss">
.delivery-note {
  table {
    border-spacing: 0;
    width: 100%;
  }
  .table-border {
    border-top: 1px solid #CCC;
    border-left: 1px solid #CCC;
  }
  table td {
    padding: 2px;
  }
  .td-border {
    border-right: 1px solid #CCC;
    border-bottom: 1px solid #CCC;
  }
  .td-label {
    font-weight: bold;
  }
  .td-right {
    text-align: right;
  }
  .td-center {
    text-align: center;
  }
  .td-padding {
    padding: 4px;
  }
  .td-italic {
    font-style: italic;
  }
  .el-input__inner {
    border: 1px solid #9ba5bb
  }
  .el-textarea__inner {
    border: 1px solid #9ba5bb;
  }
  .el-input__inner:hover {
    border-color: #1b32a7;
  }
  .el-textarea__inner:hover {
    border-color: #1b32a7;
  }
}
</style>
